import { ChevronDown } from 'lucide-react';
import { CiPlay1 } from "react-icons/ci";
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function AccordionItem({ id, title, items, lectures }) {
  const [isOpen, setIsOpen] = useState(false);
  const { courseId, modId } = useParams();
  const navigate = useNavigate();

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  // Gérer le clic sur une leçon
  const handleLessonClick = (lessonId) => {
    // Naviguer vers la leçon
    navigate(`/lesson-page/${courseId}/${modId}/${lessonId}`);

  };

  return (
    <div className="w-full bg-white dark:bg-dark-5 rounded-xl mt-2 lg:mt-7">
      <button
        onClick={toggleAccordion}
        className="w-full flex py-3 lg:py-5 px-4 lg:px-8 rounded-xl justify-between items-center text-slate-800 bg-light-4"
      >
        <span className={`text-slate-800 dark:text-white transition-transform duration-300 ${isOpen ? 'rotate-180 mr-2 lg:mr-4' : 'mr-2 lg:mr-4'}`}>
          <ChevronDown className="w-5 h-5 lg:w-6 lg:h-6" />
        </span>
        <span className='w-full items-center text-dark-1 flex text-sm lg:text-base'>{title}</span>
        <div className="text-gray-600 text-sm">{lectures}</div>
      </button>
      <div
        id={`content-${id}`}
        className={`overflow-hidden w-full rounded-xl transition-all duration-300 ease-in-out px-4 lg:px-8
          ${isOpen ? 'max-h-[1000px] py-3 lg:py-5' : 'max-h-0'}`}
      >
        {isOpen && (
          <div className="space-y-3 bg-white">
            {items.map((item) => (
              <button
                key={item.id}
                className="w-full flex justify-between items-start p-4 rounded-md font-sans cursor-pointer hover:bg-light-4"
                onClick={() => handleLessonClick(item.id)}
              >
                <div className="flex flex-1">
                  <div className="flex justify-center items-center w-8 h-8 rounded-full bg-light-4 text-purple-1 mr-3">
                    <CiPlay1 className="w-3 h-3" />
                  </div>
                  <span className="text-dark-1 text-sm flex-1">{item.title}</span>
                </div>
                <div className="flex items-center space-x-3 text-purple-1 text-xs">
                  {item.preview && <span className="underline">Preview</span>}
                  <span>{item.duration}</span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AccordionItem;